export default {
  main: {
    site_id: 1138,
    enableTouchToClick: true,
    enableWinterMode: true,
    ticketPayoutExpirationDays: 30,
    enableWinterMode: true,
    title: "Terminal PRO",
    enableWebCashier: true,
    amountToSwitchToCashMode: 9800,
    needAdminConfirmation: true,
    showCustomLockScreenMessages: true,
    hideIdColumnFromAdminPage: false,
    verificationType: "rfid",
    oktoMerchantId: "ROM22033063827",
    oktoTestMerchantId: 'DROM2410241185',
    oktoTestTerminalIds: [15348, 17993, 18673, 21536],
    hotjarId: 4937902,
    sportsIdsBlackList: [31, 184, 118, 188],
    virtualSportsWithNewLabel: [209],
    isNewStatistic: true,
    isTicketsCheckable: true,
    enableMultiDepositMode: true,
    enableThemeToggle: true,
    homeBannerSlides: [
      {
        fileType: "video",
        path: "/thirdPartyGame/112005",
      },
    ],
    disableBalanceMixing: true,
    needAdminForResetPin: true,
    alwaysShowCheckTicket: true,
    casinoIframeGameNames: ["Joker's luck", "Diamond X"],
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: true,
    showBetBuilderSection: true,
    logoSize: "115x40",
    staffPassword: "995511",
    rfidPinCode: true,
    enableMultipleTicketPay: true,
    showResultsSection: true,
    websitePasswordHash: "4b90fe42fa002772ace2a046b86b00f00f34e96bec28c1e8abcb3b561eecba47",
    enableTicketPopupFlow: true,
    enabel18PlusIcon: true,
    enableHeaderAdminSection: true,
    termsAndConditions: true,
    useBookingV2Api: true,
    homeMediaSlides: [
      {
        type: "bonus2",
        path: "betting/prematch",
      },
      {
        type: "betbuilder2",
        path: "betting/prematch/betBuilder/",
      },
      {
        type: "boosted2",
        path: "betting/prematch/all/boosted/all/all",
      },
      {
        type: "bet-chance2",
        path: "betting/prematch",
      },
      {
        type: "today2",
        path: "betting/prematch/all/multiples",
      },
      {
        type: "chain2",
        path: "betting/prematch",
      },
      {
        type: "victory2",
        path: "betting/prematch",
      },
      {
        type: "counteroffer",
        path: "betting/prematch",
      },
      {
        type: "diamondx",
        path: "thirdPartyGame/112008",
      },
      {
        type: "earlycashout",
        path: "betting/prematch",
      },
      {
        type: "oktopay",
        path: "betting/prematch",
      },
      {
        type: "shiningwheel",
        path: "thirdPartyGame/500022253",
      }
    ],
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 1,
      },
      rum: {
        short: "RO",
        name: "Rom",
        region: "Romania",
        order: 20,
      },
    },
  },
  casino: {
    enableCopyBet: true,
  },
  sportsbook: {
    virtualsSportIdsBlackList: [31, 184, 118, 188],
    timeFilter: {
      enableClassicView: true
    }
  },
  settingsSection: {
    sections: ['oddsType', 'language', 'systemView'],
  },
  depositMethods: [
    {
      type: "octopay",
      disableBalanceMixing: true,
      enabled: true,
      disabledBetshopIds: [109109, 108845, 109690, 108840, 110637, 111122, 113011, 113116, 114403, 114848, 115595, 115628],
      enabledTerminalIds: [37478]
    },
  ],
  useCurrencySymbol: false,
  enableWinIdentification: true,
  enableBoostedOdds: true,
  minWinAmountForIdentification: 16.67,
  betBuilder: {
    brandName: "lasvegas",
  },
  swarm: {
    postponeWebsocketRetry: true,
  },
  odd: {
    roundDecimalCoefficients: 3, // rounding of coefficients, number of significant digits
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Lottery tickets",
      type: "lotteryTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Pay-out",
      type: "payoutTicket",
      hideOnRestrictMode: false,
    },
  ],
  betslip: {
    enableBankerBet: false,
    enableExpressCounterOffer: true,
    bookingBetBalanceMaxLimit: 9999999,
    taxPercentOnStake: 5,
    superbetHiddenMode: true,
    enableAutomaticSuperbet: true,
    enableCounterOffer: true,
    useBalanceAsMaxStake: true,
    disableCounterOfferOnLive: true,
    "availableBetTypes": {
      "System": {
        "label": "System",
        "minSelectionsCount": 3,
        "maxSelectionsCount": 16,
        "blockAutoFixOfBetType": true,
        "minErrorMessage": "The minimum number of events for the system bet is 3",
        "maxErrorMessage": "The maximum number of events for the system bet is 16",
      }
    },
    betDetailsOrder: [
      "total_odd",
      "tax_on_stake",
      "total_stake",
      "possible_win",
      "bonus",
      "min_possible_win",
      "estimated_return",
      "tax_on_return_or_profit",
      "total_win",
      "profit_boost",
    ],
  },
  adminPageButtons: [
    {
      name: "Admin User",
      type: "adminUserSections",
      hideOnRestrictMode: false,
      enabled: true,
    },
    {
      name: "Application and terminal management",
      type: "applicationAndTerminal",
      enabled: true,
    },
    {
      name: "Tickets",
      type: "lastTicket",
      enabled: true,
    },
    {
      name: "Financial tracking",
      type: "financialTracking",
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: "Open last log file",
      type: "openLastLogFile",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Lock",
      type: "lockAndUnlock",
      param: { type: "lock" },
      enabled: true,
    },
    {
      name: "Unlock",
      type: "lockAndUnlock",
      param: { type: "unlock" },
      enabled: true,
    },
    {
      name: "Devices",
      type: "devices",
      enabled: true,
      hideOnRestrictMode: true,
    },
  ],
  env: {
    lang: "rum",
  },
  wheelConfig: {
    enableWheel: false,
    spinRotationCount: 4,
    minSelectionsCount: 3,
    minSelectionOdd: 1.2,
    minOdd: 10,
    wheelBoosts: [
      {
        name: "Profit Boost",
        value: 1,
      },
      {
        name: "Profit Boost",
        value: 5,
      },
      {
        name: "Profit Boost",
        value: 10,
      },
      {
        name: "Profit Boost",
        value: 15,
      },
      {
        name: "Profit Boost",
        value: 25,
      },
    ],
  },
  routes: [
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: false,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: false,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Games',
      enabled: true,
      url: 'thirdPartyGame/500022253',
      type: 'virtualGames',
      hasNewLabel: true,
      nestedItems: [
        {
          url: "thirdPartyGame/500022253",
          name: "Shining Wheel",
          type: 'shiningWheel',
          enabled: true,
          iframeFullscreen: false,
          icon: "shining-wheel",
          gameId: "500022253",
          gameWithSecondScreen: false,
          hasNewLabel: true,
        },
        {
          url: 'thirdPartyGame/555572885',
          name: 'Grecia Kino Luck 5',
          type: 'greciaKinoLuck5',
          iframeFullscreen: false,
          enabled: false,
          // icon: 'golden-race',
          gameId: '555572885',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/112008',
          name: 'Diamond X',
          type: 'diamondX',
          hasNewLabel: false,
          icon: 'diamond-x',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112008',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112007',
          name: "Joker's Luck",
          type: 'jockersLuck',
          hasNewLabel: false,
          icon: 'jockers-luck',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112007',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112005',
          name: 'Rocket Jet',
          type: 'rocketJet',
          icon: 'rocket-jet',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112005',
          onlyInHeader: true,
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112002',
          name: 'Book of 6',
          type: 'bookOf6',
          icon: 'book-of-six',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112002',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/112001',
          name: 'Loto',
          type: 'loto',
          icon: 'loto',
          enabled: true,
          iframeFullscreen: false,
          gameId: '112001',
          gameWithSecondScreen: false,
        },
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          type: 'goldenRace',
          iframeFullscreen: false,
          enabled: false,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
      ],
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  terminal: {
    disableTicket: false,
  },
  defaultTerminalParams: { pid: 1138, tid: 13601, token: "0IDcBQ==", currency: "RON" },
};
